import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import BookmarkRowSection from "../../components/bookmark/BookmarkRowSection";
import HeroSection from "../../components/heroSection/HeroSection";
import useQueryFetch from "../../modules/api/apiHooks/useQueryFetch";
import { getAtkHeader } from "../../modules/api/fetch/getHeaders";
import { Program } from "../../modules/graphql/api.generated";
import { GET_PROGRAMS_BOOKMARKED } from "../../modules/graphql/bookmarkGraphQL";
import { FocusContext, setFocus, useFocusable } from "../../modules/spatialNavigation";
import * as styles from "./styles.module.scss";

const BookmarkPage = () => {
  //states
  const page = useRef<number>(0);
  const [items, setItems] = useState<Program[]>([]);

  const { ref, focusKey } = useFocusable({
    trackChildren: true,
    isFocusBoundary: true,
    autoRestoreFocus: true,
    focusBoundaryDirections: ["up", "down"],
  });

  // fetch hooks
  const [getProgramsBookmarked, getProgramsBookmarkedContext] = useQueryFetch(
    process.env.TV_API_BASE_URL!,
    GET_PROGRAMS_BOOKMARKED,
    getAtkHeader,
  );

  //effects
  useEffect(() => {
    page.current = 1;
    fetchBookmarked();
  }, []);

  useEffect(() => {
    if (items.length > 0) setFocus(`bookmark-${items[(page.current - 1) * 30].id}`);
  }, [items]);

  // methods
  const fetchBookmarked = useCallback(async () => {
    const data = await getProgramsBookmarked({ page: 1 });
    setItems((prevItems) => [...prevItems, ...data.data.getProgramsBookmarked.data]);
  }, [getProgramsBookmarked, getProgramsBookmarkedContext.data, page.current]);

  const hasMore = useMemo(() => {
    const { data } = getProgramsBookmarkedContext;
    if (!data) {
      return false;
    }
    const { pagination } = data.data.getProgramsBookmarked;
    return pagination.currentPage < pagination.totalPages;
  }, [getProgramsBookmarkedContext.data]);

  const fetchNextPage = useCallback(() => {
    page.current += 1;
    fetchBookmarked();
  }, [getProgramsBookmarkedContext.data]);

  return (
    <FocusContext.Provider value={focusKey}>
      <HeroSection />
      <div ref={ref} className={styles.scrollingRows}>
        <BookmarkRowSection
          hasMorePage={hasMore}
          loadNextPage={fetchNextPage}
          data={items}
          title="لیست تماشا"
          onFocus={() => {}}
          onAssetPress={() => {}}
          focusKey="bookmark"
        />
      </div>
    </FocusContext.Provider>
  );
};
export default BookmarkPage;
